import { OrganizationType } from '@consigli/types';

import { commonValidators, ValidationRules } from '@/utils/validation';

import { CreateOrganizationFormData } from './types';

/**
 * Validation config for the organization form
 */
export const validationRules: ValidationRules<CreateOrganizationFormData> = {
  name: {
    required: true,
    minLength: 2,
    validate: (value: unknown): string | undefined => {
      return commonValidators.stringWithMinLength(
        value,
        2,
        'Name must be at least 2 characters long',
      );
    },
  },
  type: {
    required: true,
    validate: (value: unknown): string | undefined => {
      const validTypes = Object.values(OrganizationType);
      return commonValidators.enumValue(value, validTypes, 'Organization type is required');
    },
  },
  availableServices: {
    required: true,
    minItems: 1,
    validate: (value: unknown): string | undefined => {
      return commonValidators.requiredArray(value, 'At least one service must be selected');
    },
  },
} as const;
